import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import get from 'lodash/get';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import '../../../containers/UserKyc/AadharPage/Aadhar.css';
import {
  loanDocUpload,
  loanDocUploaded,
  UploadFileToS3
} from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../images/icons/upload_new.svg';
import PopUp from '../../../common/components/PopUp/PopUp';
import * as Yup from 'yup';
import '../LoanDetails/LoanDetails.css';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';

const LoanDetails = props => {
  const [checked, setChecked] = useState(false);
  const [docUploaded, setDocUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [show, setShow] = useState(true);
  const [loanDocUploads, setLoanDocUploads] = useState({});
  const [leadAppicant_Id, setLeadApplicant_Id] = useState('');
  const [lead_Id, setLead_id] = useState('');
  const [hasSanctionDoc, setHasSanctionDoc] = useState('');
  const [hasStatementDoc, setHasStatementDoc] = useState('');
  const [editStatement, setEditStatement] = useState(false);
  const [editSanction, setEditSanction] = useState(false);

  const {
    values,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFieldTouched,
    handleSubmit,
    isSubmitting,
    setStatementDocId,
    setSactionDocId,
    getSavedData,
    setUpdateAPI,
    setLoanId
  } = props;
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState('');
  const inputLength = mobile.length;
  useEffect(() => {
    let leadDetails = getApplicantionInfo();
    const { leadId, leadApplicantId } = leadDetails;
    setLead_id(leadId);
    setLeadApplicant_Id(leadApplicantId);
    // localStorage.setItem('doc_id', JSON.stringify(requestId));
    return () => {};
  }, []);
  const applyCondtn = () => {
    if (docUploaded || docUploadError || loading) return true;
  };
  // props rendered for PopUp
  const propsRenderer = () => {
    let props = {};
    if (docUploaded) {
      props.type = 'success';
      props.text = 'Document uploaded successfully';
      props.autoClose = true;
      return props;
    }
    if (docUploadError) {
      props.type = 'fail';
      props.text = 'Error uploading the file, please try again ';
      props.autoClose = true;
      return props;
    }
    if (loading) {
      props.type = 'loading';
      props.text = 'Uploading document. . . ';
      return props;
    }
  };
  useEffect(() => {
    if (getSavedData.length > 0) {
      console.log('inserted');
      setFieldValue('lender', getSavedData[0].lender);
      setFieldValue('loanType', {
        value: getSavedData[0]?.loanType || '',
        label: getSavedData[0]?.loanType || 'Select'
      });
      setFieldValue('sanctionAmount', getSavedData[0]?.sanctionAmount);
      setFieldValue('balanceAmount', getSavedData[0]?.balanceAmount);
      setFieldValue('currentEmi ', getSavedData[0]?.currentEmi);
      setFieldValue('totalTenure', getSavedData[0]?.totalTenure);
      setFieldValue('balanceTenure', getSavedData[0]?.balanceTenure);
      if (getSavedData[0]?.sanctionDoc != null) {
        setHasSanctionDoc(getSavedData[0]?.sanctionDoc?.links[0]?.url);
        setSactionDocId(getSavedData[0]?.sanctionDoc?.links[0]?.docId);
      }
      if (getSavedData[0]?.statementDoc != null) {
        setHasStatementDoc(getSavedData[0]?.statementDoc?.links[0]?.url);
        setStatementDocId(getSavedData[0]?.statementDoc?.links[0]?.docId);
      }
      setFieldValue('file', []);
      setFieldValue('imgUrl', []);
      values.file = [];
      setUpdateAPI(true);
      setLoanId(getSavedData[0].id);
    } else {
      console.log('out');
      setFieldValue('lender', '');
      setFieldValue('loanType', '');
      setFieldValue('sanctionAmount', '');
      setFieldValue('balanceAmount', '');
      setFieldValue('currentEmi ', '');
      setFieldValue('totalTenure', '');
      setFieldValue('balanceTenure', '');
      setFieldValue('file', []);
      setFieldValue('imgUrl', []);
      values.file = [];
    }
  }, []);
  const UploadFile = (index, name, tag) => {
    loanDocUpload(
      values.file[index][index],
      lead_Id,
      leadAppicant_Id,
      name,
      tag,
      { 'Content-Type': `${values.file[index][0].type}` }
    )
      .then(res => {
        let docId = res.requestId;
        UploadFileToS3(res.url, values.file[index][0], {
          'Content-Type': `${values.file[index][0].type}`
        })
          .then(res => {
            loanDocUploaded(lead_Id, leadAppicant_Id, docId, name)
              .then(res => {
                setDocUploaded(true);
                if (index == 0) {
                  setSactionDocId(docId);
                } else setStatementDocId(docId);
                setLoanDocUploads({
                  ...loanDocUploads,
                  index: 'uploaded'
                });
              })
              .catch(err => setDocUploadError(true));
          })
          .catch(err => setDocUploadError(true));
      })
      .catch(err => {
        setDocUploadError(true);
      });
  };
  useEffect(() => {
    if (values.file[0] && values.file[0] !== '') {
      setDocUploaded(false);
      setDocUploadError(false);
      setShow(true);
      setLoading(true);
      UploadFile(0, 'loan-sanctioned', 'loanSanctioned');
    }
  }, [values.file[0]]);
  useEffect(() => {
    if (values.file[1] && values.file[1] !== '') {
      setDocUploaded(false);
      setDocUploadError(false);
      setShow(true);
      setLoading(true);
      UploadFile(1, 'loan-statement', 'loanStatement');
    }
  }, [values.file[1]]);
  const handleCheckedChange = e => {
    setChecked(e.target.checked);
  };

  let loanTypeOptions = [
    {
      label: 'Home Loan',
      value: 'Home Loan'
    },
    {
      label: 'Education Loan',
      value: 'Education Loan'
    },
    {
      label: 'Auto Loan',
      value: 'Auto Loan'
    },
    {
      label: 'Personal Loan',
      value: 'Personal Loan'
    },
    {
      label: 'Small Business Loan',
      value: 'Small Business Loan'
    },
    {
      label: 'Small Business Loan',
      value: 'Small Business Loan'
    }
  ];
  return (
    <React.Fragment>
      {applyCondtn() && (
        <PopUp {...propsRenderer()} setShow={setShow} show={show} />
      )}
      <Form onSubmit={handleSubmit} className="w-full">
        <div className="bg-white py-8 md:py-1 p-2 ">
          <div className="flex-1  w-full">
            <p className="font-roboto font-normal text-black-400 text-base py-2">
              Current Obligation
            </p>
            <p className="font-roboto font-normal text-green-900 text-base py-2">
              Loan
            </p>
            <div className="block">
              <div className="w-full xl:flex block">
                <div className="w-full xl:w-6/12 xl:pt-9 pt-3 pb-3">
                  <CommonInput
                    name="lender"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.lender}
                    legendName="Lender Name"
                    error={touched.lender && errors.lender}
                    errorMsg={errors.lender}
                    touched={touched.lender}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                  />
                </div>
                <div className="w-full xl:w-6/12  py-3 mr-auto xl:ml-7 ">
                  <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                    Type of Loan
                  </div>
                  <CommonSelect sort={true}
                    name="loanType"
                    value={values.loanType}
                    onChange={e => {
                      setFieldValue('loanType', {
                        value: e.value,
                        label: e.value
                      });
                    }}
                    options={loanTypeOptions}
                    isHoverEffect
                    stylesContainer={{
                      height: '52px',
                      marginBottom: '0px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '52px',
                      color: 'rgba(0,0,0,0.87)',
                      fontSize: '16px',
                      backgroundColor: '#fff',
                      alignItems: 'center',
                      fontFamily: 'Roboto',
                      fontWeight: 400
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 25px'
                    }}
                    error={
                      touched.loanType && get(errors, 'loanType.value', false)
                    }
                    touched={touched.loanType}
                  />
                </div>
              </div>
              <div className="xl:flex block">
                <div className="w-full xl:w-6/12 py-3 overflow-hidden ">
                  <div className="w-6/12 float-left">
                    <InputTypeNumber
                      name="sanctionAmount"
                      maxLength={10}
                      minLength={0}
                      legendName={'Sanction Amount'}
                      value={values.sanctionAmount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={false}
                      error={touched.sanctionAmount && errors.sanctionAmount}
                      errorMsg={errors.sanctionAmount}
                      touched={touched.sanctionAmount}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      showInText={false}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                    />
                  </div>
                  <div className="w-6/12 pl-2 float-left">
                    <InputTypeNumber
                      name="balanceAmount"
                      maxLength={10}
                      minLength={0}
                      legendName={'Balance Amount'}
                      value={values.balanceAmount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={false}
                      error={touched.balanceAmount && errors.balanceAmount}
                      errorMsg={errors.balanceAmount}
                      touched={touched.balanceAmount}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      showInText={false}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                    />
                  </div>
                </div>
                <div className="w-full xl:w-6/12 py-3 xl:ml-7">
                  <InputTypeNumber
                    name="currentEmi"
                    maxLength={10}
                    minLength={0}
                    legendName={'Current EMI'}
                    value={values.currentEmi}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={false}
                    error={touched.currentEmi && errors.currentEmi}
                    errorMsg={errors.currentEmi}
                    touched={touched.currentEmi}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showInText={false}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                  />
                </div>
              </div>
              <div className="w-full xl:flex block ">
                <div className="w-full xl:w-6/12 py-3">
                  <CommonInput
                    name="totalTenure"
                    type='tel'
                    disabled=""
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.totalTenure}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="Total Tenure in Months"
                    error={touched.totalTenure && errors.totalTenure}
                    errorMsg={errors.totalTenure}
                    touched={touched.totalTenure}
                  />
                </div>
                <div className="w-full xl:w-6/12 xl:ml-7 py-3">
                  <CommonInput
                    name="balanceTenure"
                    disabled=""
                    type='tel'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.balanceTenure}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="Balance Tenure in Months"
                    error={touched.balanceTenure && errors.balanceTenure}
                    errorMsg={errors.balanceTenure}
                    touched={touched.balanceTenure}
                  />
                </div>
              </div>
              <div className="xl:flex block sm:py-5">
                <div className={`w-full xl:w-5/12 py-3 upload_loan`}>
                  <p className="font-roboto font-normal text-grey-920 text-base py-3 sm:hidden">
                    Loan Sanction Letter
                  </p>
                  {hasSanctionDoc != '' && !editSanction ? (
                    <ShowGetImage
                      img={hasSanctionDoc}
                      setEdit={setEditSanction}
                    />
                  ) : (
                    <GlobalUploadComp
                      data={values}
                      imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      initialImg={initialImg} // initial image
                      subInst="Click here to Upload Loan Sanction Letter"
                      subtext="Loan Sanction Letter"
                    />
                  )}
                </div>
                <div className={`w-full xl:w-5/12 py-3 upload_loan xl:ml-5`}>
                  <p className="font-roboto font-normal text-grey-920 text-base py-3 sm:hidden">
                    Loan Statement
                  </p>
                  {hasStatementDoc != '' && !editStatement ? (
                    <ShowGetImage
                      img={hasStatementDoc}
                      setEdit={setEditStatement}
                    />
                  ) : (
                    <GlobalUploadComp
                      data={values}
                      imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      initialImg={initialImg} // initial image
                      subInst="Click here Upload Loan Statement"
                      subtext="Loan Statement"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </React.Fragment>
  );
};
export default LoanDetails;
